import Api from './../api'
import { AxiosResponse} from "axios";

export default (body : any): Promise<AxiosResponse> => {
    const path = `/market-place/init-flow`
    return Api.getInstance().request.post(`${path}`,body, path)
}
